import { flexRender } from '@tanstack/react-table';
import { TableCell, TableRow } from '@src/design-system/table';
import { cn } from '@src/design-system/helpers';
import { getPinningStyles } from './styles';

import type { Row } from '@tanstack/react-table';
import type { VirtualItem, Virtualizer } from '@tanstack/react-virtual';
import { copyToClipboard } from '@shared/utils';

interface TableRowComponentProps<T> {
  row: Row<T>;
  rowIndex?: number;
  virtualRow?: VirtualItem;
  rowVirtualizer?: Virtualizer<HTMLDivElement, HTMLTableRowElement>;
}

export default function TiclickTableRow<T>({
  row,
  rowIndex,
  virtualRow,
  rowVirtualizer,
}: TableRowComponentProps<T>) {
  return (
    <TableRow
      data-index={virtualRow?.index}
      ref={(el) => {
        if (!rowVirtualizer) return;
        rowVirtualizer.measureElement(el);
      }}
      data-state={row.getIsSelected() ? 'selected' : undefined}
      className={cn(
        rowIndex && rowIndex % 2 === 1 ? 'bg-primary-50' : undefined,
        'data-[state=selected]:border-b border-pale-border'
      )}
    >
      {row.getVisibleCells().map((cell) => {
        const { column } = cell;
        const isPinned = column.getIsPinned();
        const isLastLeftPinned =
          isPinned === 'left' && column.getIsLastColumn('left');
        const isFirstRightPinned =
          isPinned === 'right' && column.getIsFirstColumn('right');
        return (
          <TableCell
            ref={(node) => {
              if (!node) return;
              node.title = node?.textContent || '';
            }}
            onClick={(e) => {
              if (column.columnDef.meta?.isCopy) {
                const text = (e.currentTarget.textContent || '').trim();
                if (text) {
                  copyToClipboard(text);
                }
              }
            }}
            style={{
              ...getPinningStyles(column),
              // ...(isPinned ? {} : { position: 'unset' }),
            }}
            data-pinned={isPinned || undefined}
            data-last-col={
              isLastLeftPinned
                ? 'left'
                : isFirstRightPinned
                  ? 'right'
                  : undefined
            }
            key={cell?.id}
            className={cn(
              'last:py-0 truncate',
              'border-primary-100 border-b data-pinned:backdrop-blur-xl  [&[data-pinned=left][data-last-col=left]]:border-r [&[data-pinned=right][data-last-col=right]]:border-l'
            )}
          >
            {flexRender(cell?.column?.columnDef?.cell, cell?.getContext())}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
